'use client';
import React from 'react';
import AnnouncementBar from '@/components/AnnouncementBar';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const checkItems = [
'Value discretion, flexibility, and a highly individualised approach',
'Are balancing demanding professional or personal responsibilities',
'Require a high level of continuity and accessibility',
'Are managing complex or fluctuating psychological difficulties',
'Prefer a more integrated and closely coordinated model of care'];


export default function ConciergeCarePage() {
  return (
    <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }} suppressHydrationWarning>
      <AnnouncementBar />
      <Header />

      <main>
        {/* ── Page Hero (boats image — unchanged) ── */}
        <section
          className="relative w-full overflow-hidden"
          style={{
            backgroundColor: '#1A2332',
            paddingTop: 'clamp(72px, 9vw, 128px)',
            paddingBottom: 'clamp(72px, 9vw, 128px)'
          }}
          suppressHydrationWarning>
          
          <div
            style={{
              position: 'absolute',
              inset: 0,
              backgroundImage: 'url(/assets/images/caafd6b8-dbf0-44a5-8466-b5662cea9e2e-1782134491881.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }} />
          
          <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(26,35,50,0.62)' }} />
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)'
            }}>
            
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '20px'
              }}>
              
              Concierge Care
            </p>
            <h1
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(36px, 5vw, 72px)',
                fontWeight: '400',
                color: '#F5F0EA',
                lineHeight: '1.1',
                maxWidth: '640px',
                marginBottom: '28px'
              }}>
              
              Specialist Care,<br />
              <span style={{ fontStyle: 'normal' }}>tailored to you</span>
            </h1>
          </div>
        </section>

        {/* ── Section 1: Concierge-style care ── */}
        <section
          className="w-full"
          style={{
            backgroundColor: '#FFFFFF',
            paddingTop: 'clamp(72px, 9vw, 112px)',
            paddingBottom: 'clamp(72px, 9vw, 112px)'
          }}>
          
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)'
            }}>
            
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
              {/* Text */}
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '11px',
                    letterSpacing: '0.18em',
                    textTransform: 'uppercase',
                    color: '#8A9E8C',
                    marginBottom: '16px'
                  }}>
                  
                  A discreet, personalised service
                </p>
                <h2
                  style={{
                    fontFamily: 'orpheus-pro, Georgia, serif',
                    fontSize: 'clamp(26px, 3vw, 44px)',
                    fontWeight: '400',
                    color: '#1A2332',
                    lineHeight: '1.2',
                    marginBottom: '28px'
                  }}>
                  
                  Concierge-style care
                </h2>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: 'clamp(16px, 1.3vw, 19px)',
                    color: '#4A4A4A',
                    lineHeight: '1.85',
                    maxWidth: '580px'
                  }}>
                  
                  I offer a discreet concierge-style service for individuals seeking highly personalised psychological care delivered with continuity, flexibility, and privacy. This service is designed for clients who value a more integrated and responsive approach to psychological support.
                </p>
              </div>
              {/* Image */}
              <div
                style={{
                  flex: '0 0 auto',
                  width: 'clamp(280px, 38%, 480px)',
                  aspectRatio: '4/5',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                
                <img
                  src="/assets/images/image-1783810805512.png"
                  alt="Dark elegant desk in a private library office with warm ambient lighting"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} />
                
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 2: Who this may be suitable for ── */}
        <section
          className="w-full"
          style={{
            backgroundColor: '#FFFFFF',
            paddingTop: 'clamp(72px, 9vw, 112px)',
            paddingBottom: 'clamp(72px, 9vw, 112px)'
          }}>
          
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)'
            }}>
            
            {/* Section heading */}
            <div style={{ maxWidth: '640px', marginBottom: 'clamp(40px, 5vw, 64px)' }}>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: '11px',
                  letterSpacing: '0.18em',
                  textTransform: 'uppercase',
                  color: '#8A9E8C',
                  marginBottom: '16px'
                }}>
                
                Is this right for you?
              </p>
              <h2
                style={{
                  fontFamily: 'orpheus-pro, Georgia, serif',
                  fontSize: 'clamp(26px, 3vw, 44px)',
                  fontWeight: '400',
                  color: '#1A2332',
                  lineHeight: '1.2',
                  marginBottom: '20px'
                }}>
                
                Who this may be suitable for
              </h2>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: 'clamp(16px, 1.3vw, 19px)',
                  color: '#4A4A4A',
                  lineHeight: '1.85'
                }}>
                
                This approach may be helpful for individuals who:
              </p>
            </div>

            {/* Visual checklist grid */}
            <div
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
              style={{ gap: 'clamp(20px, 3vw, 32px)' }}>
              
              {checkItems.map((item, idx) =>
              <div
                key={idx}
                style={{
                  backgroundColor: '#F7F2EF',
                  padding: 'clamp(24px, 3vw, 36px)',
                  borderTop: '2px solid #8A9E8C'
                }}>
                
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                    <span
                    style={{
                      flexShrink: 0,
                      width: '24px',
                      height: '24px',
                      backgroundColor: '#8A9E8C',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: '1px'
                    }}>
                    
                      <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
                        <path d="M1 4.5L4.5 8L11 1" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <p
                    style={{
                      fontFamily: 'adobe-garamond-pro, Georgia, serif',
                      fontSize: 'clamp(15px, 1.2vw, 18px)',
                      color: '#1A2332',
                      lineHeight: '1.7',
                      margin: 0
                    }}>
                    
                      {item}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* ── Dark interstitial quote banner ── */}
        <section
          className="w-full"
          style={{
            backgroundColor: '#1A2332',
            paddingTop: 'clamp(56px, 7vw, 88px)',
            paddingBottom: 'clamp(56px, 7vw, 88px)'
          }}>
          
          <div
            style={{
              maxWidth: '800px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)',
              textAlign: 'center'
            }}>
            
            <p
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(20px, 2.5vw, 32px)',
                fontWeight: '400',
                color: '#F5F0EA',
                lineHeight: '1.6',
                fontStyle: 'italic'
              }}>
              
              "The little things are infinitely the most important"
            </p>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: 'clamp(13px, 1.1vw, 16px)',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginTop: '20px'
              }}>
              — Sir Arthur Conan Doyle
            </p>
          </div>
        </section>

        {/* ── Section 3: A tailored model of care ── */}
        <section
          className="w-full"
          style={{
            backgroundColor: '#F7F2EF',
            paddingTop: 'clamp(72px, 9vw, 112px)',
            paddingBottom: 'clamp(72px, 9vw, 112px)'
          }}>
          
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)'
            }}>
            
            <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20">
              {/* Image */}
              <div
                style={{
                  flex: '0 0 auto',
                  width: 'clamp(360px, 54%, 640px)',
                  aspectRatio: '3/4',
                  position: 'relative',
                  overflow: 'hidden',
                  marginLeft: '-40px'
                }}>
                
                <img
                  src="/assets/images/image_2026-07-12_153112976-1783866673931.png"
                  alt="Structured around individual need — personalised concierge psychological care"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }} />
                
              </div>
              {/* Text */}
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '11px',
                    letterSpacing: '0.18em',
                    textTransform: 'uppercase',
                    color: '#8A9E8C',
                    marginBottom: '16px'
                  }}>
                  
                  Structured around individual need
                </p>
                <h2
                  style={{
                    fontFamily: 'orpheus-pro, Georgia, serif',
                    fontSize: 'clamp(26px, 3vw, 44px)',
                    fontWeight: '400',
                    color: '#1A2332',
                    lineHeight: '1.2',
                    marginBottom: '24px'
                  }}>
                  
                  A tailored model of care
                </h2>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: 'clamp(16px, 1.3vw, 19px)',
                    color: '#4A4A4A',
                    lineHeight: '1.85',
                    marginBottom: '28px'
                  }}>
                  
                  Concierge care is a bespoke way of structuring psychological support around individual need. Depending on circumstances, this may include:
                </p>
                {/* Bespoke list */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '28px' }}>
                  {[
                  'Flexible scheduling of appointments',
                  'Increased continuity of contact where clinically appropriate',
                  'Extended sessions or intensified periods of therapeutic input',
                  'Integration of assessment, formulation, and therapy within a single coherent care pathway',
                  'Collaboration with other professionals involved in your care'].
                  map((item, idx) =>
                  <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                      <span
                      style={{
                        flexShrink: 0,
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(138,158,140,0.18)',
                        border: '1px solid #8A9E8C',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '2px'
                      }}>
                      
                        <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                          <path d="M1 4L3.5 6.5L9 1" stroke="#8A9E8C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                      <p
                      style={{
                        fontFamily: 'adobe-garamond-pro, Georgia, serif',
                        fontSize: 'clamp(15px, 1.2vw, 18px)',
                        color: '#4A4A4A',
                        lineHeight: '1.7',
                        margin: 0
                      }}>
                      
                        {item}
                      </p>
                    </div>
                  )}
                </div>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: 'clamp(15px, 1.2vw, 18px)',
                    color: '#4A4A4A',
                    lineHeight: '1.85',
                    fontStyle: 'italic'
                  }}>
                  
                  Each arrangement is individually agreed, ensuring that support is clinically appropriate, clearly structured, and responsive to changing needs over time.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 4: Clinical foundation ── */}
        <section
          className="w-full"
          style={{
            backgroundColor: '#FFFFFF',
            paddingTop: 'clamp(72px, 9vw, 112px)',
            paddingBottom: 'clamp(72px, 9vw, 112px)'
          }}>
          
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)'
            }}>
            
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
              {/* Text */}
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '11px',
                    letterSpacing: '0.18em',
                    textTransform: 'uppercase',
                    color: '#8A9E8C',
                    marginBottom: '16px'
                  }}>
                  
                  Grounded in evidence-based practice
                </p>
                <h2
                  style={{
                    fontFamily: 'orpheus-pro, Georgia, serif',
                    fontSize: 'clamp(26px, 3vw, 44px)',
                    fontWeight: '400',
                    color: '#1A2332',
                    lineHeight: '1.2',
                    marginBottom: '28px'
                  }}>
                  
                  Clinical foundation
                </h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <p
                    style={{
                      fontFamily: 'adobe-garamond-pro, Georgia, serif',
                      fontSize: 'clamp(16px, 1.3vw, 19px)',
                      color: '#4A4A4A',
                      lineHeight: '1.85'
                    }}>
                    
                    Although flexible in structure, all concierge care remains firmly grounded in clinical formulation, evidence-based practice, and professional boundaries.
                  </p>
                  <p
                    style={{
                      fontFamily: 'adobe-garamond-pro, Georgia, serif',
                      fontSize: 'clamp(16px, 1.3vw, 19px)',
                      color: '#4A4A4A',
                      lineHeight: '1.85'
                    }}>
                    
                    Every aspect of care is guided by a comprehensive psychological formulation, ensuring that the work remains coherent, focused, and psychologically meaningful rather than reactive or unstructured.
                  </p>
                </div>
              </div>
              {/* Image */}
              <div
                style={{
                  flex: '0 0 auto',
                  width: 'clamp(280px, 38%, 480px)',
                  aspectRatio: '4/5',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                
                <img
                  src="/assets/images/mountain-landscape.png"
                  alt="Serene mountain landscape with a clear blue sky and white clouds"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} />
                
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 5: Working together ── */}
        <section
          className="w-full"
          style={{
            backgroundColor: '#EFE3E1',
            paddingTop: 'clamp(72px, 9vw, 112px)',
            paddingBottom: 'clamp(72px, 9vw, 112px)'
          }}>
          
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(24px, 4vw, 64px)'
            }}>
            
            <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20">
              {/* Image */}
              <div
                style={{
                  flex: '0 0 auto',
                  width: 'clamp(320px, 50%, 600px)',
                  aspectRatio: '4/3',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                
                <img
                  src="/assets/images/image-1783886538203.png"
                  alt="Two women sharing coffee together in a warm, relaxed setting"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} />
                
              </div>
              {/* Text */}
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '11px',
                    letterSpacing: '0.18em',
                    textTransform: 'uppercase',
                    color: '#8A9E8C',
                    marginBottom: '16px'
                  }}>
                  
                  Next steps
                </p>
                <h2
                  style={{
                    fontFamily: 'orpheus-pro, Georgia, serif',
                    fontSize: 'clamp(26px, 3vw, 44px)',
                    fontWeight: '400',
                    color: '#1A2332',
                    lineHeight: '1.2',
                    marginBottom: '28px'
                  }}>
                  
                  Working together
                </h2>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: 'clamp(16px, 1.3vw, 19px)',
                    color: '#4A4A4A',
                    lineHeight: '1.85',
                    marginBottom: '40px'
                  }}>
                  
                  Concierge arrangements are discussed on an individual basis following an initial consultation. My aim is to provide a contained, thoughtful and highly personalised therapeutic relationship, with the appropriate level of flexibility to support meaningful psychological work.
                </p>
                <a
                  href="/contact"
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '13px',
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    color: '#EFE3E1',
                    backgroundColor: '#1A2332',
                    padding: '15px 40px',
                    textDecoration: 'none',
                    display: 'inline-block',
                    transition: 'background-color 0.25s ease'
                  }}
                  onMouseEnter={(e) => (e.currentTarget as HTMLElement).style.backgroundColor = '#2C2C2C'}
                  onMouseLeave={(e) => (e.currentTarget as HTMLElement).style.backgroundColor = '#1A2332'}>
                  
                  Arrange a Consultation
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>);

}